import { render, staticRenderFns } from "./LoyaltyMobile.vue?vue&type=template&id=3b0ede0e"
import script from "./LoyaltyMobile.vue?vue&type=script&lang=js"
export * from "./LoyaltyMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports